export default "__VITE_ASSET__DHW9_diA__"